import { backend, domain } from 'modules/data';
import { memo } from 'react';

import ActivitySection from '../../card/ActivitySection';
import AttachmentsSection from '../../card/AttachmentsSection';
import { WorkflowSection } from '../../card/WorkflowSection';
import QBooksJournalEntryFields from './components/QBooksJournalEntryFields/QBooksJournalEntryFields';
import QBooksJournalEntryFooter from './components/QBooksJournalEntryFooter/QBooksJournalEntryFooter';
import QBooksJournalEntryLines from './components/QBooksJournalEntryLines/QBooksJournalEntryLines';
import QBooksJournalEntryMemoSection from './components/QBooksJournalEntryMemoSection/QBooksJournalEntryMemoSection';
import { QBooksJournalEntryCardProps } from './QBooksJournalEntryCard.types';

const QBooksJournalEntryCard = memo<QBooksJournalEntryCardProps>((props) => {
    const { company, currency, details, request } = props;

    if (
        request.integrationType !== domain.IntegrationType.QBooks ||
        request.integrationCode !== domain.IntegrationCode.QBooksJournalEntry
    ) {
        return null;
    }

    const isAUOrg = company?.integration?.countryCode === backend.OrganisationVersion.QBO_AU;

    return (
        <>
            <QBooksJournalEntryFields request={request} />

            <QBooksJournalEntryLines currency={currency} lines={details.lines} />

            <QBooksJournalEntryFooter
                currency={currency}
                debitSubTotal={details.debitSubTotal}
                creditSubTotal={details.creditSubTotal}
                debitTaxTotal={details.debitTotalTax}
                creditTaxTotal={details.creditTotalTax}
                taxComponents={details.taxComponents}
                lineAmountType={details.lineAmountType}
                editUrl={details.editUrl}
                url={details.url}
                isAUOrg={isAUOrg}
            />

            <QBooksJournalEntryMemoSection memo={details.memo} />

            <AttachmentsSection request={request} />

            <WorkflowSection request={request} />

            <ActivitySection request={request} />
        </>
    );
});

export default QBooksJournalEntryCard;
